import { Component, EventEmitter, HostListener, inject, Inject, OnDestroy, OnInit, Optional, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TreeGridComponent } from '@syncfusion/ej2-angular-treegrid';
import { OtherVacationsPopupComponent } from './other-vacations-popup/other-vacations-popup.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { vrStatuses } from '../../model/vacation-request.model';
import { VacationRequestService } from '../../vacation-request.service';
import { ColumnChooserService, ExcelExportProperties } from '@syncfusion/ej2-angular-grids';
import { OutOfOfficeService } from '../../../out-of-office/services/out-of-office.service';
import { AlertMessages, UserRoles } from 'projects/sales/src/app/shared/constants/app.constants';
import { RenderDayCellEventArgs } from '@syncfusion/ej2-angular-calendars';
import { SharedService } from 'projects/shared/src/lib/shared.service';
import { VacationRequestsPopupService } from 'projects/shared/src/lib/vacation-requests-popup.service';
import { convertDateFormat, getCurrentDate } from 'projects/sales/src/app/shared/models/utils/date-functions';
import { getExcelDataSource, gridActionsForFiltering, updateFilterIcon } from 'projects/shared/src/lib/utils/grid-functions';
import { ModuleNames, RolePermissionsModel, tabsModel, ToolbarEnum } from 'projects/shared/src/lib/models/lib.model';
import { APP_CONFIG, AppConfig } from 'projects/shared/src/lib/app-config.token';

@Component({
    selector: 'app-vacation-requests-popup',
    templateUrl: './vacation-requests-popup.component.html',
    styleUrls: ['./vacation-requests-popup.component.scss'],
    providers: [ColumnChooserService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VacationRequestsPopupComponent implements OnInit, OnDestroy {
  private readonly vacationRequestsPopupService = inject(VacationRequestsPopupService);
  impactsGrid!: TreeGridComponent;
  toolbarOptions: any = [];
  hasUnsavedChanges: boolean = false;
  isMaximized: boolean = true;
  gridHeight: number = 500;
  DDLs: any = {
    statusDDL: {},
    productDDL: {},
    customerTypeDDL: {},
    saleTypeDDL: {}
  }
  userHolidays: any[] = [];
  commentCount: any;
  moduleName: ModuleNames = ModuleNames.VacationRequest;
  tab: any;

  @ViewChild('impactsTreeGrid') set gridComponent(gridComponent: TreeGridComponent) {
    if (gridComponent) {
      this.impactsGrid = gridComponent;
    }
  }
  impactsGridColumns: any[] = [];
  showResourcesPopup: boolean = false;
  // canEdit: boolean = true;

  @ViewChild('columnChooser') columnChooser: any;
  vrStatuses: typeof vrStatuses = vrStatuses;
  showLoader: any;
  showPopup: any;
  showProspectsPopup: boolean = false;
  prospectData: any;
  popupPermissions: any;
  isCreating: boolean = false;
  tabsModel: typeof tabsModel = tabsModel;
  title: string = 'Create Request';
  vacReqForm!: FormGroup<any>;
  PERMISSIONS: RolePermissionsModel[] = [];
  VacationRequestService: typeof VacationRequestService = VacationRequestService;

  startOfTheYear: Date;
  impactData: any[] = [];
  selectionSettings: Object = { allowColumnSelection: false, checkboxOnly: true, mode: 'None' };
  sum: number = 0;

  attColorCode: any = '';
  linkColorCode: any ='';

  constructor(
    private vrService: VacationRequestService,
    private ooService: OutOfOfficeService,
    private fb: FormBuilder,
    public dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<VacationRequestsPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public popupData: any,
    @Inject(APP_CONFIG) public config: AppConfig,
    public sharedService: SharedService
  ) { 
    this.tab = popupData?.tab ?? tabsModel.details;
  }
  ngOnInit() {
    this.startOfTheYear = new Date(new Date().getFullYear(), 0, 1);
    this.isCreating = !this.popupData?.vrfId;
    this.initForm();
    this.setGridHeight(true);
    this.loadPermissions();
    this.impactsGridColumns = this.getImpactsGridColumns();
    this.fetchRemainingDaysData(this.popupData?.userId ?? this.sharedService.getUSER()?.userId);
    this.getUserHolidays();
    window.visualViewport?.addEventListener('resize', this.onViewportResize);
  }

  ngOnDestroy() {
    window.visualViewport?.removeEventListener('resize', this.onViewportResize);
  }

  private readonly onViewportResize = () => this.resetViewportScroll();

  // iPad Safari scrolls the page to make room for the on-screen keyboard and doesn't always scroll it back once the
  // keyboard closes. The popup still paints in place, but taps then land on whatever is below the tapped point
  // (close icon toggles a section, tabs/comments don't open), so move the page back to the top.
  @HostListener('document:focusout')
  resetViewportScroll() {
    setTimeout(() => {
      const viewport = window.visualViewport;
      const isKeyboardOpen = !!viewport && viewport.height * viewport.scale < document.documentElement.clientHeight - 100;
      if (!isKeyboardOpen && (window.scrollY !== 0 || (viewport?.offsetTop ?? 0) !== 0)) {
        window.scrollTo(0, 0);
      }
    }, 300);
  }

  onTabChange(tabName: string) {
    this.tab = tabName;
  }

  onRenderCell(args: RenderDayCellEventArgs): void {
    // const dateToCheck = new Date(args.date).toISOString().split('T')[0];
    const dateToCheck = new Date(args.date).getFullYear()+"-"+(String(new Date(args.date).getMonth()+1).padStart(2, '0'))+"-"+String(new Date(args.date).getDate()).padStart(2, '0');

    const isDatePresent = this.userHolidays.some(date => date.startsWith(dateToCheck));
    if (isDatePresent) {
      args.isDisabled = true;
    }
  }
  getUserHolidays() {
    this.sharedService.getUserHolidays(this.popupData?.userId ?? this.sharedService.getUserId(), new Date().getFullYear().toString(), "submitted_vr,approved_vr").subscribe({
      next: (data: any) => {
        this.userHolidays = Array.from(new Set(data.value.map(item => item.date.split('Z')[0])));
        this.printUserHolidaysWithoutWeekends(data.value);

      },
      error: (error) => {
        console.error('Error fetching posts:', error);
      },
      complete: () => {
        console.log('User holidays fetch complete');
      },
    });
  }
  printUserHolidaysWithoutWeekends(d: any[]): any {
    const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const months = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"];

        function getOrdinalSuffix(day) {
            if (day > 3 && day < 21) return day + 'th'; // 11th–13th
            switch (day % 10) {
                case 1: return day + "st";
                case 2: return day + "nd";
                case 3: return day + "rd";
                default: return day + "th";
            }
        }
        console.log('userHolidays without weekends');
        d.forEach(m => {
            const d = new Date(m.date);
            const dayOfWeek = weekdays[d.getDay()];

            if (d.getDay() !== 0 && d.getDay() !== 6) { // Skip Sunday and Saturday
                const day = getOrdinalSuffix(d.getDate());
                const month = months[d.getMonth()];
                const year = d.getFullYear();
                console.log(`${m.type} ==> ${dayOfWeek} ${day} ${month}, ${year}`);
            }
        });
  }

  // isDisableDate(dateToCheck: string): boolean {
  //   const dateFormatted = new Date(dateToCheck).toISOString().split('T')[0];
  //   return this.userHolidays.some(date => date.startsWith(dateFormatted));
  // }
  // calculateDaysBetweenDates(startDate: Date, endDate: Date): number {
  //   const msPerDay = 1000 * 60 * 60 * 24;
  //   const diffInMs = new Date(endDate).getTime() - new Date(startDate).getTime();
  //   const totalDays = Math.floor(diffInMs / msPerDay);

  //   let disabledDaysCount = 0;
  //   for (let i = 0; i <= totalDays; i++) {
  //     const currentDate = new Date(startDate);
  //     currentDate.setDate(currentDate.getDate() + i);

  //     // Check if the current date is a disabled date (holiday)
  //     if (this.isDisableDate(currentDate.toString())) {
  //       disabledDaysCount++;
  //     }
  //   }

  //   // Subtract the number of disabled days from the total days
  //   return totalDays - disabledDaysCount;
  // }

  loadPermissions(
    category: string = 'outOfOfficeRequest',
    subCategory: string = 'outOfOfficeRequest_Popup',
    id: string = '',
    module: string = ''
  ) {
    this.vrService.apiCallStarted("loadPermissions");
    this.sharedService.getRolePermission(category, subCategory, module, id)
      .subscribe({
        next: (res: any) => {
          this.PERMISSIONS = res?.result ?? [];
          !this.isCreating && this.loadData(false);
          this.vrService.apiCallCompleted("loadPermissions");
        },
        error: (err: any) => {
          this.PERMISSIONS = [];
          this.vrService.apiCallCompleted("loadPermissions");
        }
      });
  }
  fetchRemainingDaysData(userId: string) {
    this.vrService.apiCallStarted("getOutOfOfficeById");
    this.ooService.getOutOfOfficeById(userId, new Date().getFullYear()).subscribe({
      next: (d: any) => {
        const data = d?.value[0];
        this.vrService.apiCallCompleted("getOutOfOfficeById");
        this.vacReqForm.get('remainingVacation').setValue((data?.entitleVacation - data?.usedVacation - data?.reqVacation) || 0);
        this.vacReqForm.get('remainingFloating').setValue((data?.entitleFloating - data?.usedFloating - data?.reqFloating) || 0);
        this.vacReqForm.get('remainingSick').setValue((data?.entitleSick - data?.usedsick - data?.reqSick) || 0);
      },
      error: (err: any) => {
        this.vrService.apiCallCompleted("getOutOfOfficeById");
      }
    })
  }
  getPermission(ruleAction: string): RolePermissionsModel {
    return this.PERMISSIONS?.find((e: RolePermissionsModel) => e.ruleAction === ruleAction)!;
  }
  loadData(showAlertMessage: boolean) {
    this.vrService.apiCallStarted("getVacationReqById");
    this.vrService.getVacationReqById(this.popupData?.vrfId)
      .subscribe({
        next: (res: any) => {
          this.vrService.apiCallCompleted("getVacationReqById");
          
          res.result = this.parseDateStringsWithoutLastZ(res.result, ['startDate', 'endDate', 'approvedDate', 'submissionDate']);

          this.vacReqForm.patchValue(res?.result, { emitEvent: true });
          this.vacReqForm.get("endDate").setValue(convertDateFormat(new Date(res?.result?.endDate)));
          this.vacReqForm.get("startDate").setValue(convertDateFormat(new Date(res?.result?.startDate)));
          let sumOfOtherDays: number = 0;
          (res?.result?.other as any[]).forEach((cv: any) => sumOfOtherDays += cv.days);
          this.vacReqForm.get("otherDays").setValue(sumOfOtherDays);
          this.updateTotalDays();
          this.popupData = res?.result;
          this.hasUnsavedChanges = false;
          this.sharedService.globalComments.commentCount = res?.result?.commentCount;
          this.sharedService.globalComments.commentColor = res?.result?.commentColor;
          this.popupData?.showComments && this.showComments();
          this.enableDisableInputs();
          this.updateImpactGrid(showAlertMessage);
        }
      });
  }
  parseDateStringsWithoutLastZ(result: any, dates: any[]): any {
    dates.map(d => {
      let date = result[d];
      if(typeof(date) == 'string' && date.includes('Z')) {
       date = (date as string).replace('Z', '');
      }
      return date;
    });
    return result;
  }
  enableDisableInputs() {
    const inputs = ['startDate', 'sick', 'floating', 'vacation'];
    inputs.forEach((c: any) => {
      this.popupData?.canEdit ? this.vacReqForm.get(c).enable() : this.vacReqForm.get(c).disable();
    });
  }
  initForm() {
    this.vacReqForm = this.fb.group({
      reporter: [{ value: this.popupData?.reporter, disabled: true }],
      status: [{ value: this.isCreating ? vrStatuses.open : this.popupData?.status, disabled: true }],
      vacation: [0],
      floating: [0],
      sick: [0],
      comment: '',
      startDate: [null, Validators.required],
      endDate: [{ value: null, disabled: true }],
      otherDays: [{ value: 0, disabled: true }],
      totalDays: [{ value: 0, disabled: true }],
      remainingVacation: [{ value: 0, disabled: true }],
      remainingFloating: [{ value: 0, disabled: true }],
      remainingSick: [{ value: 0, disabled: true }],
    },
      {
        validators: this.dateValidation,
      }
    );
  }
  dataBound() {
    this.impactsGrid.toolbar = [ 'Search',
      { id: ToolbarEnum.columnChooser, template: this.columnChooser, tooltipText: 'Show/Hide Columns' },
      { id: ToolbarEnum.expandall, text: '', tooltipText: 'Expand All', prefixIcon: 'e-expand' },
      { id: ToolbarEnum.collapseall, text: '', tooltipText: 'Collapse All', prefixIcon: 'e-collapse', align: 'Left' },
      { id: ToolbarEnum.clearFilter, text: '', align: 'Right', prefixIcon: 'fas fa-filter ', cssClass: 'grid-filter-icon', tooltipText: 'Clear all Filters' },
      ];
      
        if (this.sharedService.getUSER()?.role !== UserRoles.salesRep) {
          const indexExcelExport = this.impactsGrid.toolbar.findIndex(fi => fi == 'Search');
          this.impactsGrid.toolbar.splice(indexExcelExport + 1, 0,  { text: '', id: 'excel-export', align: 'Right', prefixIcon: 'e-excelexport', tooltipText: 'Excel Export' })
        }
  }

    onToolbarClick(args: any) {
      if (args.item.id === ToolbarEnum.expandall) {
        (this.impactsGrid as TreeGridComponent).expandAll();
      } else if (args.item.id === ToolbarEnum.collapseall) {
        (this.impactsGrid as TreeGridComponent).collapseAll();
      } else if (args.item.id === ToolbarEnum.excelExport) {
        const dataSource = getExcelDataSource(this.impactsGrid);
        let excelExportProperties: ExcelExportProperties = {
          dataSource,
          hierarchyExportMode: 'Expanded',
          theme: {
            header: { bold: true, backColor: '#eeeeee', fontSize: 15 }
          },
          fileName: `Impacts (${getCurrentDate()}).xlsx`
        };
        this.impactsGrid.excelExport(excelExportProperties);
      } else if (args.item.id === ToolbarEnum.clearFilter) {
        this.impactsGrid.clearFiltering();
        this.impactsGrid.clearSorting();
        this.impactsGrid.search('');
        this.impactsGrid.refresh();
      }
    }
  getImpactsGridColumns() {
    let columns = [
      { field: 'title', headerText: 'Title', type: 'string', allowEditing: false, textAlign: 'Left', width: 190, visible: true, showInColumnChooser: false, filter: { type: 'Menu' } },
      { field: 'customer', headerText: 'Customer', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: false, filter: { type: 'Excel' } },
      { field: 'type', headerText: 'Type', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: false, filter: { type: 'Excel' } },
      { field: 'status', headerText: 'Status', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true, filter: { type: 'Excel' } },
      { field: 'startDate', headerText: 'Planned Date', type: 'date', format: { type: 'date', format: 'd MMM, y' }, allowEditing: false, textAlign: 'Left', width: 140, visible: true, showInColumnChooser: true, },
    ];
    return columns;
  }
  preventTyping(event: KeyboardEvent): void {
    event.preventDefault();
  }

  dateValidation(formGroup: FormGroup) {
    const startDate = formGroup.get('startDate')?.value;
    const endDate = formGroup.get('endDate')?.value;
    if (startDate && endDate && new Date(endDate) < new Date(startDate)) {
      formGroup.get('endDate')?.setErrors({ invalidEndDate: true });
    }
    return null;
  }


  actionComplete(args: any, grid: any) {
    gridActionsForFiltering(args, grid);
    updateFilterIcon(args, grid);
  }
  openOtherVRPopup(mode: 'canEdit' | 'readOnly') {
    const OTHER = JSON.parse(JSON.stringify(this.popupData.other));
    const dialogRef = this.dialog.open(OtherVacationsPopupComponent, {
      disableClose: true,
      maxWidth: '720px',
      maxHeight: '520px',
      width: '100%',
      height: '100%',
      panelClass: 'bringToTop',
      enterAnimationDuration: '0',
      exitAnimationDuration: '0',
      data: { popupData: this.popupData, mode },
    });
    dialogRef.afterClosed().subscribe((d: any) => {
      if (d?.isInteracted) {
        let totalOtherDays = 0;
        (d?.result as any[]).forEach((d: any) => { totalOtherDays += d.days });
        this.vacReqForm.get('otherDays').setValue(totalOtherDays);
        this.hasUnsavedChanges = d?.isInteracted;
        this.fetchEndDateAndImpacts(d);
      } else {
          this.popupData.other = OTHER;
      }

    });
  }

  isStartDateMissing(): any {
    let opt: boolean = false;
    if (!this.vacReqForm.controls['startDate'].value && this.vacReqForm?.touched) {
      opt = !(!this.vacReqForm.controls['vacation'].value
        && !this.vacReqForm.controls['floating'].value
        && !this.vacReqForm.controls['sick'].value
        && !this.vacReqForm.controls['otherDays'].value);
    }
    return opt;
  }
  isRequestedDaysSectionInvalid(): any {
    let opt: boolean = false;
    if (this.vacReqForm?.touched) {
      opt = (!this.vacReqForm.controls['vacation'].value
        && !this.vacReqForm.controls['floating'].value
        && !this.vacReqForm.controls['sick'].value
        && !this.vacReqForm.controls['otherDays'].value);
    }
    return opt;
  }
  getControl(control: string) {
    return this.vacReqForm.get(control);
  }
  onResourcesPopupClose(rowData: any) {
    this.showResourcesPopup = false;
    if (typeof(rowData) == 'object') {
      this.vacReqForm.get('reporter').setValue(rowData['employeeName']);
      this.popupData.userId = rowData['userId'];
      this.fetchRemainingDaysData(this.popupData?.userId);
      this.getUserHolidays();
      this.resetForm();
    }

  }
  getFieldValue(field: string) {
    let val = this.vacReqForm.controls[field]?.value;
    typeof(val) == 'string' && (val = val.trim());
    return val;
  }
  updateTotalDays() {
    this.vacReqForm.get("totalDays").setValue((this.getFieldValue('vacation') ?? 0) + (this.getFieldValue('sick') ?? 0) + (this.getFieldValue('floating') ?? 0) + (this.vacReqForm.get("otherDays")?.value ?? 0));
    this.vacReqForm.get("totalDays").updateValueAndValidity();
  }
  fetchEndDateAndImpacts(e: any) {
    // from input changes and date change
    if(e?.isInteracted) {
      setTimeout(() => {
        // check if all valid conditions are met, otherwise show errors???
        // if(e === true) {
          this.updateTotalDays();
          this.hasUnsavedChanges = true;
          if(!this.vacReqForm.get("startDate").value) { return; }
          this.vrService.apiCallStarted("getEndDate");
          this.vrService.getEndDate({
            duration: this.vacReqForm.get("totalDays").value,
            startDate: convertDateFormat(this.vacReqForm.get("startDate").value),
            userId: this.popupData?.userId ?? this.sharedService.getUSER()?.userId
          }).subscribe({
            next: (res: any) => {
              this.vrService.apiCallCompleted("getEndDate");
              this.vacReqForm.get("endDate").setValue(convertDateFormat(res?.value[0]?.endDate));
              this.updateImpactGrid(true);
            }
          });
        // }
      }, 200);
    }
  }
  getEndDateValue(): any {
    return new Date(this.vacReqForm.get("endDate").value).toLocaleDateString('en-US');
  }
  getStartDateValue(): any {
    return new Date(this.vacReqForm.get("startDate").value).toLocaleDateString('en-US');
  }
  updateImpactGrid(showAlertMessage: boolean) {
    this.vrService.apiCallStarted("getImpact");
    this.vrService.getImpact({
      userId: this.popupData?.userId ?? this.sharedService.getUSER()?.userId,
      startDate: this.getStartDateValue(),
      endDate: this.getEndDateValue()
    }).subscribe({
      next: (res: any) => {
        this.vrService.apiCallCompleted("getImpact");
        this.impactData = res?.value as any[];
        // A task with no planned/end date comes back as null; new Date(null) is 1 Jan 1970, so keep null (an empty cell).
        const toDate = (value: any) => value ? new Date(value) : null;
        this.impactData.map(id => {
          id.startDate = toDate(id.startDate);
          id.endDate = toDate(id.endDate);
          id['isOverdue'] = id.type == 'ToDo' && !!id.startDate && id.startDate < new Date(Date.now());
          return id;
        });
        if(this.impactData?.length > 0 && this.isCreating) {
      showAlertMessage && this.sharedService.showConfirmation("The out of office request dates are overlapping with one or more sales process activities/Todos. You may edit the dates on these activities/Todos manually using the opportunity/Todo hyperlinks.", "Ok", "Cancel", "", "info").then((res: any) => {});
    }
      }
    })
  }
  resetForm() {
     ["vacation", "floating", "sick", "totalDays", "otherDays"].forEach((c: any) => this.vacReqForm.get(c).setValue(0));
        ["startDate", "endDate"].forEach((c: any) => this.vacReqForm.get(c).setValue(null));
        this.popupData.other = [];
        this.impactData = [];
        this.impactsGrid?.refresh();
        this.vacReqForm.markAsUntouched();
  }
  resetPopup() {
    if(this.hasUnsavedChanges) {
      if(this.isCreating) {
       this.resetForm();
      } else {
        this.sharedService.resetAlert((res: boolean) => {
          if (res) {
            this.loadData(false);
          }
        });
      }
    } else {
      this.sharedService.showNotification('warning','No change detected')
    }
  }

  showComments() {
    this.sharedService.globalComments.module = ModuleNames.VacationRequest;
    this.sharedService.globalComments.moduleId = this.popupData?.vrfId;
    this.sharedService.globalComments.showComments = true;
  }

  rejectRequest() {
    this.vrService.showCommentOnRejectionModal(this.popupData)
    .then((resp: any) => {
      this.loadData(false);
    });
  }
  updateStatusTo(status: string) {
    this.popupData['status'] = status;
    this.vrService.updateStatusTo(this.popupData).subscribe({
      next: (res: any) => {
        this.sharedService.showNotification("success", res);
        this.loadData(false);
      }
    });
  }
  savePopup(close?: boolean, updatedStatus?: vrStatuses) {
  setTimeout(() => {
    if(!this.getFieldValue("totalDays") || !this.vacReqForm.get("startDate").value) {
      const text = (close === false && updatedStatus == vrStatuses.submitted) ? 'submitting' : 'creating';
      this.sharedService.showNotification("info", `Please add some vacations and select start date before ${text} the request!`);
      this.vacReqForm.markAsTouched();
      return;
    }
    if(
      this.getFieldValue('remainingFloating') - this.getFieldValue('floating') < 0 ||
      this.getFieldValue('remainingVacation') - this.getFieldValue('vacation') < 0 ||
      this.getFieldValue('remainingSick') - this.getFieldValue('sick') < 0
  ) {
      this.sharedService.showNotification("info","Requested days cannot be greater than remaining days!");
      return;
    }
    if(
      new Date(this.getEndDateValue()).getFullYear() != new Date().getFullYear()
  ) {
      this.sharedService.showNotification("info","End date does not lie within the current year!");
      return;
    }
    this.popupData.other = (this.popupData?.other as any[]).map((d: any) => {
      if (d.id === undefined)  {
        d.id = 0;
        d.vrfId = 0;
      }
      d.userId === undefined ? d.userId = (this.popupData?.userId ?? this.sharedService.getUSER()?.userId) : null;
      return d;
    });
    const status = this.vrService.getVRStatus(updatedStatus) ?? this.vrService.getVRStatus(this.popupData?.status);
    let payload = {
      "dateFrom": this.getStartDateValue(),
      "dateTo": this.getEndDateValue(),
      "floating": this.getFieldValue('floating'),
      "isDeleted": false,
      "comment": this.getFieldValue('comment') ?? '',
      "other": this.popupData?.other,
      "sick": this.getFieldValue('sick'),
      "status":  status,
      "userId": this.popupData?.userId ?? this.sharedService.getUserId(),
      "vacation": this.getFieldValue('vacation'),
      "vrfId": this.popupData?.vrfId,
      "approvedBy": null,
      "approvedDate": null,
    }
    this.vrService.apiCallStarted("saveVacationRequest");
    this.vrService.saveVacationRequest(payload)
    .subscribe({
      next: (res: any) => {
        this.vrService.apiCallCompleted("saveVacationRequest");
        res.data = this.parseDateStringsWithoutLastZ(res?.data, ['startDate', 'endDate', 'approvedDate', 'submissionDate']);

        this.popupData = res?.data;
        this.vacReqForm.patchValue(res?.data);
        this.vacReqForm.controls['endDate'].setValue(convertDateFormat(new Date(res?.data?.endDate)));
        this.vacReqForm.get("startDate").setValue(convertDateFormat(new Date(res?.data?.startDate)));
        // this.updateTotalDays(); // joelle should fix this issue; RIMSSL-10545
        this.hasUnsavedChanges = false;
        this.enableDisableInputs();
        close && this.close(close);
        const text = (close === false && updatedStatus == vrStatuses.submitted) ? 'submitted' : 'created';
        this.sharedService.showNotification("success", `Vacation request ${text} successfully!`);
      },
      error: (err: any) => {
        let error = typeof err == 'string' ? err : err?.message;
        this.sharedService.showNotification("error", err?.error.message || err?.message);
        this.vrService.apiCallCompleted("saveVacationRequest");
      }
    });
}, 250);
  }
  onFieldChange(e: any, c: string) {
    if(e?.isInteracted) {
      const v = e?.value || 0;
      switch (c) {
        case 'vacation':
          if ((this.vacReqForm.get('remainingVacation').value - v) < 0) {
            this.sharedService.showNotification("info","Requested days cannot be greater than remaining days!");
            this.vacReqForm.get(c).setValue(0);
          } else { //equals to zero or any poistive number remains
            this.vacReqForm.get(c).setValue(v);
          }
          this.vacReqForm.get(c).updateValueAndValidity();
          break;
          case 'floating':
          if ((this.vacReqForm.get('remainingFloating').value - v) < 0) {
            this.sharedService.showNotification("info","Requested days cannot be greater than remaining days!");
            this.vacReqForm.get(c).setValue(0);
            } else { //equals to zero or any poistive number remains
              this.vacReqForm.get(c).setValue(v);
            }
          this.vacReqForm.get(c).updateValueAndValidity();
          break;
          case 'sick':
          if ((this.vacReqForm.get('remainingSick').value - v) < 0) {
            this.sharedService.showNotification("info","Requested days cannot be greater than remaining days!");
            this.vacReqForm.get(c).setValue(0);
          } else { //equals to zero or any poistive number remains
            this.vacReqForm.get(c).setValue(v);
          }
          this.vacReqForm.get(c).updateValueAndValidity();

          break;
      }
      setTimeout(() => {
        this.updateTotalDays();
      }, 250);
    }
  }
  get popupTitle(): string {
    return this.popupData?.vrfId && this.popupData?.vrfId !== '' ? this.popupData?.vrfId : 'Create Request';
  }
  parseType(type: string) {
      type.toLowerCase() === 'salesorder' && (type = 'Sales Order');
      return type;
    }
  openSalesOrderPopup(id: string) {
    this.vacationRequestsPopupService
      .openSalesOrder(id)
      .subscribe(() => {
      });

    }
  setGridHeight(isMaximized: boolean): void {
    this.isMaximized = isMaximized;
    if (window.innerWidth < 1650) {
      this.gridHeight = isMaximized ? window.innerHeight - 590 : window.innerHeight * 0.8 - 590;
    } else {
      this.gridHeight = isMaximized ? window.innerHeight - 570 : window.innerHeight * 0.8 - 570;
    }
    this.gridHeight = Math.max(this.gridHeight, 100);
  }

  recenterDialog() {
    setTimeout(() => {
      this.dialogRef.updatePosition({ top: '50%', left: '50%' });
      this.dialogRef.updatePosition(); // This line is necessary to properly recenter the dialog
    }, 0);
  }

  openOpportunityPopup(
    id: string = null,
    tab = 'details'
  ): void {
    this.vacationRequestsPopupService
      .openOpportunity(id, tab)
      .subscribe(() => {
        this.updateImpactGrid(false);
      });
  }

  openToDosPopup(id: string): void {
    this.vacationRequestsPopupService
      .openToDo(id)
      .subscribe(() => {
        this.updateImpactGrid(false);
      });
  }

  openProspectPopup(customerId: string): void {
    this.vacationRequestsPopupService
      .openProspect(customerId)
      .subscribe(() => {
        this.updateImpactGrid(false);
      });
  }
//   openOpportunityPopup(id: string = null, tab = 'details') {
//     const dialog = this.dialog.open(OpportunitiesPopupComponent, {
//       backdropClass: 'no-backdrop',
//       disableClose: true,
//       maxWidth: '100vw',
//       maxHeight: '100vh',
//       width: '100%',
//       height: '100%',
//       enterAnimationDuration: '0',
//       exitAnimationDuration: '0',
//       autoFocus: false,
//       data: {
//         id: id,
//         isMaximized: true,
//         type: 'indirect',
//         tab: tab,
//         forcfullyOpenEditActivitesPopupForVacationRequests: true
//       }
//     });
//     dialog.afterClosed().subscribe(result => {
//       this.updateImpactGrid();
//     });
//   }
// openToDosPopup(id: string) {
//     const dialog = this.dialog.open(ToDosPopupComponent, {
//       backdropClass: 'no-backdrop',
//       disableClose: true,
//       maxWidth: '100vw',
//       maxHeight: '100vh',
//       width: '100%',
//       height: '100%',
//       enterAnimationDuration: '0',
//       exitAnimationDuration: '0',
//       autoFocus: false,
//       data: {
//         todoId: id,
//         isMaximized: true
//       }
//     });
//     dialog.afterClosed().subscribe(result => {
//       this.updateImpactGrid();
//      });
//   }

//   openProspectPopup(customerId: string) {
//     this.prospectData = { soldToExtId: customerId };
//     this.showProspectsPopup = true;
//     const dialogRef = this.dialog.open(ProspectsPopupComponent, {
//       backdropClass: 'no-backdrop',
//       disableClose: true,
//       maxWidth: '100vw',
//       maxHeight: '100vh',
//       width: '100%',
//       height: '100%',
//       enterAnimationDuration: '0',
//       exitAnimationDuration: '0',
//       data: {
//         showProspectsPopup: this.showProspectsPopup,
//         prospectData: this.prospectData,
//         id: this.prospectData.soldToExtId,
//         tab: tabsModel.details,
//         isMaximized: true,
//         // isReadOnly: true,
//       },
//     });

//     dialogRef.afterClosed().subscribe((result) => {
//       this.updateImpactGrid();
//     });
//   }

  showUnsavedChangesAlert() {
    this.sharedService.showConfirmation(AlertMessages.unsavedChangesLost)
    .then(res => {
      if(res.isConfirmed) {
        this.dialogRef?.close(false);
      }
    });
  }
  close(opt?: boolean) {
    if(this.hasUnsavedChanges) {
      this.showUnsavedChangesAlert();
    } else {
      this.dialogRef?.close(true);
    }
  }
}
